<template>
  <section>
    <!-- <Navbar class="mobile"/> -->


    <!-- //TITLE MOBILE -->
    <h1 class="mobile">{{general.resumeTitle}}</h1>
    <!-- //TITLE MOBILE -->

    <!-- //ILLUSTRATION MOBILE -->
    <div class="mobile block__illustrationHorizontal mb-5">
      <div class="info">
        <h3 class="title">
          <PuSkeleton :loading="isLoading" :count="1" width="200px">          
            {{content.illustration.title}}
          </PuSkeleton>
        </h3>
        <PuSkeleton :loading="isLoading" :count="2">                          
          <p class="desc" v-html="content.illustration.desc"></p>
        </PuSkeleton>
      </div>
      <img :src="content.illustration.src" alt="illustration">
    </div>   
    <!-- //ILLUSTRATION MOBILE -->



    <!-- //CONTENT -->
    <div class="content__resume overflow">
      <b-row>
        <!-- PART MIDDLE -->
        <b-col class="column-middle">


          <!-- //FAVORIS MOBILE-->
          <section class="mobile favoris">
            <div class="head entete">
              <div>
                <h2>{{general.favorite}}</h2>
                <a href="" class="btn btn-blue">{{general.modify}}</a>
              </div>
              
              <a href="" class="btn btn-blue">{{general.labelAll}}</a>
            </div>


            <!-- SLIDER MOBILE -->
            <div class="block__slider">
              <VueSlickCarousel v-bind="settings">
                <div  class="wrapper">
                    <div class="subHeader mb-2">
                      <span>
                        <font-awesome-icon :icon="['far', 'chart-bar']" />
                      </span>
                      <div class="title">Production <span>Nombre</span></div>
                    </div>

                    <cardSmallLight 
                    :title = production.title
                    :link = production.id
                    :parent = production.id
                    :number = production.number
                    :resultOne = production.resultOne
                    :resultTwo = production.resultTwo
                    :date = production.date
                    :dateTwo = production.dateTwo
                    />
                </div>

                <div  class="wrapper">
                  <div class="subHeader mb-2">
                    <span class="blue">
                      <font-awesome-icon :icon="['far', 'file-times']" />
                    </span>
                    <div class="title">Résiliation <span>Nombre</span></div>
                  </div>

                  <cardSmallLight 
                  :title = resiliation.title
                  :link = resiliation.id
                  :parent = resiliation.id
                  :number = resiliation.number
                  :resultOne = resiliation.resultOne
                  :resultTwo = resiliation.resultTwo
                  :date = resiliation.date
                  :dateTwo = resiliation.dateTwo
                  />              
                </div>


                <div  class="wrapper">
                  <div class="subHeader  mb-2">
                    <span class="green">
                      <font-awesome-icon :icon="['far', 'user-graduate']" />
                    </span>
                    <div class="title">Complétude clients</div>
                  </div>

                  <cardSmallLight 
                  :title = completude.title
                  :link = completude.id
                  :parent = completude.id
                  :number = completude.number
                  :resultOne = completude.resultOne
                  :resultTwo = completude.resultTwo
                  :date = completude.date
                  :dateTwo = completude.dateTwo
                  />
                </div>
              </VueSlickCarousel>
            </div>
            <!-- SLIDER MOBILE -->

          </section>
          <!-- //FAVORIS MOBILE-->


          <!-- //TITLE DESKTOP -->
          <h1 class="desktop">{{general.resumeTitle}}</h1>
          <!-- //TITLE DESKTOP -->


          <!-- //ILLUSTRATION DESKTOP -->
          <div class="desktop block__illustrationHorizontal">
            <div class="info">
              <h3 class="title">
                  <PuSkeleton :loading="isLoading" :count="1" class="blueSkeleton">                          
                    {{content.illustration.title}}
                  </PuSkeleton>
              </h3>
              <div class="content__desc">
              <PuSkeleton :loading="isLoading" :count="2" class="blueSkeleton">                          
                <p class="desc" v-html="content.illustration.desc"></p>
              </PuSkeleton>
              </div>
            </div>
            <img :src="content.illustration.src" alt="illustration">
          </div>   
          <!-- //ILLUSTRATION DESKTOP -->


          <!-- //CHIFFRE -->
          <section class="numbers">
            <div class="head">
              <h2>{{general.resumeTrackingNumbers}}</h2>
              <a href="" class="btn btn-blue">{{general.formBtBrowse}}</a>
            </div>
            <div class="sep"></div>

            <!-- SLIDER MOBILE -->
            <div class="block__slider cardSimple mobile">
              <VueSlickCarousel v-bind="settings">
                <div  class="wrapper">
                  <b-card class="card-simple">
                    <div class="number">
                      <PuSkeleton :loading="isLoading" :count="1">  
                          15
                      </PuSkeleton>                      
                    </div>
                    <div class="title">
                      <PuSkeleton :loading="isLoading" :count="2">  
                        Nouveau critère positif
                      </PuSkeleton>                      
                    </div>
                  </b-card>
                </div>

                <div  class="wrapper">
                  <b-card class="card-simple text-yellow">
                      <div class="number">
                        <PuSkeleton :loading="isLoading" :count="1">  
                          10
                        </PuSkeleton>                          
                      </div>
                      <div class="title">
                        <PuSkeleton :loading="isLoading" :count="2">                    
                          Nouveau critère négatif
                        </PuSkeleton>                        
                      </div>
                    </b-card>           
                </div>

                <div  class="wrapper">
                  <b-card class="card-simple text-white">
                    <div class="number">
                      <PuSkeleton :loading="isLoading" :count="1"  class="blueSkeleton">  
                        65%
                      </PuSkeleton>                       
                    </div>
                    <div class="title">
                      <PuSkeleton :loading="isLoading" :count="2"  class="blueSkeleton">                    
                        De taux positif
                      </PuSkeleton>                      
                    </div>
                  </b-card>
                </div>
              </VueSlickCarousel>
            </div>
            <!-- SLIDER MOBILE -->

            <!-- //CARD SIMPLE DESKTOP -->
            <b-row class="block__cardSimple">
              <b-col cols="4">
                <b-card class="card-simple">
                  <div class="number">
                    <PuSkeleton :loading="isLoading" :count="1">  
                      15
                    </PuSkeleton>
                  </div>
                  <div class="title">
                    <PuSkeleton :loading="isLoading" :count="2">  
                      Nouveau critère positif
                    </PuSkeleton>
                  </div>
                </b-card>
              </b-col>
              <b-col cols="4">
                <b-card class="card-simple text-yellow">
                  <div class="number">
                    <PuSkeleton :loading="isLoading" :count="1">  
                      10
                    </PuSkeleton>                    
                  </div>
                  <div class="title">
                    <PuSkeleton :loading="isLoading" :count="2">                    
                      Nouveau critère négatif
                    </PuSkeleton>
                  </div>
                </b-card>
              </b-col>
              <b-col cols="4">
                <b-card class="card-simple text-white">
                  <div class="number">
                    <PuSkeleton :loading="isLoading" :count="1"  class="blueSkeleton">  
                      65%
                    </PuSkeleton>                    
                  </div>
                  <div class="title">
                    <PuSkeleton :loading="isLoading" :count="2"  class="blueSkeleton">                    
                      De taux positif
                    </PuSkeleton>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!-- //CARD SIMPLE DESKTOP -->


          </section>
          <!-- //CHIFFRE -->



          <!-- //OBJECTIFS -->
            <section class="objectifs">
              <div class="head">
                <h2>{{general.resumeTrackingObjectives}}</h2>
                <router-link class="btn btn-blue" to="./objectifs">{{general.labelAll}}</router-link>
              </div>
              <div class="sep"></div>
              <listObjectiveResume />
            </section>
          <!-- //OBJECTIFS -->


          <!-- //SUIVI -->
            <section class="suivi">
              <div class="head">
                <h2>{{general.resumeTrackingCommercials}}</h2>
                <router-link class="btn btn-blue" to="./commerciaux">{{general.labelAll}}</router-link>

              </div>
              <div class="sep"></div>
              <listCommercialResume/>
            </section>
            <!-- //SUIVI -->


          <!-- //CHALLENGES -->
            <section class="challenge">
              <div class="head">
                <h2>{{general.resumeChallengesProgress}}</h2>
                <router-link class="btn btn-blue" to="./challenges">{{general.labelAll}}</router-link>
              </div>
              
              <div class="sep"></div>

              <!-- SLIDER MOBILE -->
              <div class="block__slider mobile">
                <VueSlickCarousel v-bind="settings">
                  <div  class="wrapper">
                    <cardChallengesPicture
                    subtitle = 'Jeu concours'
                    title = 'Pura Vida'
                    targetTitle = 'En cours'
                    ranking = "Classement"
                    rankingNumber = "82"
                    rankingResult = "15"
                    score = "score"
                    scoreNumber = "250"
                    target = "+1"
                    />
                  </div>

                  <div  class="wrapper">
                    <cardChallengesDate
                    title = 'Chiffre d’affaire AN personnalisé'
                    subtitle = 'Chiffre d’affaire AN'
                    startDate = '04/04/2020'
                    endDate = "04/05/2020"
                    objectiveNumber = "120 000"
                    inprogress = "58 000"
                    deadline = "60"
                    state = "en cours"
                    />         
                  </div>

                </VueSlickCarousel>
              </div>
              <!-- SLIDER MOBILE -->

              <div class="desktop">
                <b-row>
                  <b-col sm="12" lg='6'>
                    <cardChallengesPicture
                    subtitle = 'Jeu concours'
                    title = 'Pura Vida'
                    targetTitle = 'En cours'
                    ranking = "Classement"
                    rankingNumber = "82"
                    rankingResult = "15"
                    score = "score"
                    scoreNumber = "250"
                    target = "+1"
                    />
                  </b-col>   
                  <b-col sm="12" lg='6'>
                    <cardChallengesDate
                    title = 'Chiffre d’affaire AN personnalisé'
                    subtitle = 'Chiffre d’affaire AN'
                    startDate = '04/04/2020'
                    endDate = "04/05/2020"
                    objectiveNumber = "120 000"
                    inprogress = "58 000"
                    deadline = "60"
                    state = "en cours"
                    />
                  </b-col>                         
                </b-row>
              </div>

            </section>
          <!-- //CHALLENGES -->

        </b-col>
        <!-- PART MIDDLE -->



        <!-- PART RIGHT -->
        <b-col sm="12" md="12" class="col-right desktop column-right borderLeft">
          <div class="head">
            <div>
              <h2>{{general.favorite}}</h2>
              <a href="" class="btn btn-blue">{{general.modify}}</a>
            </div>
            
            <a href="" class="btn btn-blue">{{general.labelAll}}</a>
          </div>
          <div class="sep"></div>

          <div class="subHeader mb-2">
            <span>
              <font-awesome-icon :icon="['far', 'chart-bar']" />
            </span>
            <div class="title">Production <span>Nombre</span></div>
          </div>

          <cardSmallLight 
          :title = production.title
          :link = production.id
          :parent = production.id
          :number = production.number
          :resultOne = production.resultOne
          :resultTwo = production.resultTwo
          :date = production.date
          :dateTwo = production.dateTwo
          />
          
          <div class="subHeader mb-2">
            <span class="blue">
              <font-awesome-icon :icon="['far', 'file-times']" />
            </span>
            <div class="title">Résiliation <span>Nombre</span></div>
          </div>

          <cardSmallLight 
          :title = resiliation.title
          :link = resiliation.id
          :parent = resiliation.id
          :number = resiliation.number
          :resultOne = resiliation.resultOne
          :resultTwo = resiliation.resultTwo
          :date = resiliation.date
          :dateTwo = resiliation.dateTwo
          />



          <div class="subHeader  mb-2">
            <span class="green">
              <font-awesome-icon :icon="['far', 'user-graduate']" />
            </span>
            <div class="title">Complétude clients</div>
          </div>

          <cardSmallLight 
          :title = completude.title
          :link = completude.id
          :parent = completude.id
          :number = completude.number
          :resultOne = completude.resultOne
          :resultTwo = completude.resultTwo
          :date = completude.date
          :dateTwo = completude.dateTwo
          />


          <a href="" class="bt btn-showAll">{{general.seeAllFavorites}}</a>
        </b-col>
        <!-- PART RIGHT -->


      </b-row> 
    </div>
    <!-- //CONTENT -->

  </section>
</template>




<script>
import { mapGetters } from 'vuex'
import listObjectiveResume from '../../../module/list/ListObjectiveResume'
import listCommercialResume from '../../../module/list/ListCommercialResume'
import cardChallengesPicture from '../../../module/card/CardChallengesPicture'
import cardChallengesDate from '../../../module/card/CardChallengesDate'
import cardSmallLight from '../../../module/card/CardSmallLight'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ApiService from '../../../../services/ApiService'
import ApiAuthentificationService from '../../../../services/ApiAuthenticationService'
// import Navbar from '../../../module/Navbar'


export default {
  name:"resumeHome",
    components:{
      listObjectiveResume,
      listCommercialResume,
      cardChallengesPicture,
      cardChallengesDate,
      cardSmallLight,
      VueSlickCarousel,
      // Navbar
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
        'getResume',
        'getResumeFavorisProduction',
        'getResumeFavorisResiliation',
        'getResumeFavorisCompletude'
      ])
    },
    data () {
      return {
        content:"",
        general:"",
        isLoading:true,
        production: [],
        resiliation: [],
        completude: [],
        settings: {
            "focusOnSelect": true,
            "infinite": false,
            "slidesToShow": 1,
            "variableWidth": true,
            "speed": 500,
            "initialSlide": 0,
            "arrow":false      
            // "responsive": [
            //             {
            //               "breakpoint": 6000,
            //               "settings": {
            //                 "centerMode": true,
            //                 "slidesToShow": 1,
            //                 "slidesToScroll": 3,
            //                 "initialSlide": 1,
            //                 "swipe":false
            //               }
            //             },
            //             {
            //               "breakpoint": 1023,
            //               "settings": {
            //                 "centerMode": false,
            //                 "slidesToShow": 1,
            //                 "initialSlide": 0,
            //                 "slidesToScroll": 1,
            //                 "swipe":true
            //               }
            //             }
            //           ]
        }   
      }
    },
    created (){
      this.general = this.getGeneral;
      this.content = this.getResume;
      this.production = this.getResumeFavorisProduction;
      this.resiliation = this.getResumeFavorisResiliation;
      this.completude = this.getResumeFavorisCompletude;

    setTimeout(() => {
        this.isLoading = false;
        // this.majData();
      },2000)         
    }, 
    mounted(){
      // Resume date
      //EN ATTENTE

      // Suivi des chiffres
      const getResume = ApiService.getProfilApi().getResume(ApiAuthentificationService.getCurrentUser().id);
      console.log("mounted -> getResume", getResume)

      // Suivi des objectifs
      // En attente

      // Commerciaux suivi
      //A vérifier => undefined
      const commercialsFavorites = ApiService.getObjectifMonitoringApi().getFollowCommercialList(ApiAuthentificationService.getCurrentUser().id);
      console.log("mounted -> commercialsFavorites", commercialsFavorites)
      

      //Challenge progress
      const concoursProgress = ApiService.getConcoursApi().get();
      console.log("mounted -> concoursProgress", concoursProgress)

      const challengesProgress = ApiService.getChallengeApi().get(ApiAuthentificationService.getCurrentUser().id);
      console.log("mounted -> challengesProgress", challengesProgress)
      
      // Colonne de droite
      const AllFavorites = ApiService.getProfilApi().getFavorites(ApiAuthentificationService.getCurrentUser().id);
      console.log("mounted -> AllFavorites", AllFavorites)
    },
    methods : {}
};
</script>
